import styled from "styled-components";
import { Button, Table,Form } from "semantic-ui-react";

export const Container = styled.div`
  background: #ffffff;
  padding-left:250px;
  `;

export const Content = styled.div`
  padding: 1rem;
  width: 100%;
`;

export const Title = styled.h1`
  width: 100%;
  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;
